import React from 'react';

import {
    OPEN_MODAL,
    CLOSE_MODAL,
    OPEN_LOADER,
    CLOSE_LOADER
} from './../Action-type/Index';

const initialState = {
    open: false,
    openLoader: true,
    children: <></>
}

function modalReducer(state = initialState, action) {
    switch (action.type) {
        case OPEN_MODAL: return { ...state, open: true, children: action.payload.children };
        case CLOSE_MODAL: return { ...state, open: false };        
        case OPEN_LOADER: return { ...state, openLoader: true };
        case CLOSE_LOADER: return { ...state, openLoader: false };        
        default: return { ...state };
    }
}

export default modalReducer;